export const SUGGESTED_QUESTIONS = [
  //'Summarise this customer.',
  //'Any fraud risk on this account?',
  'Summarise this customers upcoming bookings',
  'Summarise this customers recent credit history',
];

export const SUGGESTED_DRAFT_ACTIONS = [
  'Draft a response explaining their refund options',
  'Write an email with their booking details',
  'Compose a reply about their loyalty status',
];

export const DEPARTMENT_OPTIONS = ['Sales', 'Customer Support', 'Tours', 'Cruises', 'Flight Support'];

export interface CustomerContext {
  customerId?: string | null;
  customerName?: string | null;
  orderId?: string | null;
  department?: string | null;
  mode?: 'default' | 'fraud';
  page?: string | null;
}
